import classes from './Badge.module.scss';

interface CircleBadgeProps {
  count: string
}

/**
 * Returns the Square badge to show count
 */
const CircleBadge = ({ count }: CircleBadgeProps) => (
  <div className={classes['cp-circle-badge']} data-testid="sr-counter-badge">
    <div className={classes['cp-circle-badge-text']}>
      {count}
    </div>
  </div>
  );

  export default CircleBadge;
